import React from 'react';
import { isKA } from '../../../common/config/utils';
import { SvgIcon } from '../../../common/sprites';
import { isActiveRoute } from '../routes/routes_helpers';
import classes from './classes.module.scss';

const getIconToUse = ({ iconName, path, needChekActive }) => {
  let iconToUse = iconName;
  if (needChekActive) {
    const pathActive = isActiveRoute(path);
    iconToUse = pathActive ? `${ iconName }_active` : iconName;
  }
  return iconToUse;
};

export const renderSideMenuIcon = ({
  iconName, path, needChekActive = true,  style = {}
}) => {
  if (isKA()) return null;
  const iconToUse = getIconToUse({ iconName, path, needChekActive });
  return (
    <SvgIcon id={ iconToUse } className={ classes.menuItemIcon } style={ { ...style } } />
  );
};
